import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@carbon/react';
import { LogoFacebook } from '@carbon/react/icons';

type Props = { onSelect: (provider: 'google' | 'facebook') => void };

// @carbon/react/icons has no LogoGoogle in the pinned 11.70.0 icon set, so the
// Google "G" is drawn inline (same single-path shape as the removed LogoGoogle).
export const GoogleIcon = ({ size = 20, className }: { size?: number; className?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
    <path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81z" />
  </svg>
);

export const SocialButtons = ({ onSelect }: Props) => {
  const { t } = useTranslation('authentication');
  const googleEnabled = import.meta.env.VITE_SOCIAL_GOOGLE === 'true';
  const facebookEnabled = import.meta.env.VITE_SOCIAL_FACEBOOK === 'true';

  if (!googleEnabled && !facebookEnabled) {
    return null;
  }

  return (
    <div className="cds--auth__social">
      {googleEnabled && (
        <Button kind="tertiary" renderIcon={GoogleIcon} onClick={() => onSelect('google')}>
          {t('social.google')}
        </Button>
      )}
      {facebookEnabled && (
        <Button kind="tertiary" renderIcon={LogoFacebook} onClick={() => onSelect('facebook')}>
          {t('social.facebook')}
        </Button>
      )}
    </div>
  );
};

export default SocialButtons;
